import type { BadgeProps } from '@chakra-ui/react';
import { Badge, FormatNumber, Span } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface VatInfoProps extends BadgeProps {
  amount: number;
  currency: string;
  fontSize?: string;
  fontWeight?: string;
}

/**
 * Displays a line like: incl. [amount] VAT
 */
export const VatInfo: React.FC<VatInfoProps> = ({
  amount,
  currency,
  colorPalette = 'gray',
  size = 'xs',
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Badge gap={0} colorPalette={colorPalette} size={size} w="fit-content" {...props}>
      {t('payouts.vat.including')}
      <Span px={0.5}>
        <FormatNumber value={amount} currency={currency} style="currency" />
      </Span>
      {t('payouts.vat.text')}
    </Badge>
  );
};

export default VatInfo;
